import { useNavigate } from 'react-router-dom';
import { OnboardingCheckout } from '@/components/onboarding/onboarding-checkout';

export default function OnboardingCheckoutPage() {
  const navigate = useNavigate();

  const handleComplete = () => {
    navigate('/');
  };

  return (
    <div className="min-h-screen bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-4xl w-full mx-auto">
        <div className="bg-white rounded-lg shadow-sm p-8">
          <OnboardingCheckout onComplete={handleComplete} />
        </div>
      </div>
    </div>
  );
}
